import {defineMessages} from 'react-intl';

export const SearchListItemMessages = defineMessages({
  UPCOMING: {
    id: 'Search.Result.upcomingevents',
    defaultMessage: 'Upcoming events',
    description: 'The contant for the Upcoming events the search suggestions',
  },
  EVENTS: {
    id: 'Search.Result.EVENTS',
    defaultMessage: 'Events',
    description: 'The Heading for the EVENTS Section for the search suggestions',
  },
  ARTIST: {
    id: 'Search.Result.ARTISTS',
    defaultMessage: 'Artists',
    description: 'The Heading for the ARTISTS Section for the search suggestions',
  },
  TEAM: {
    id: 'Search.Result.TEAM',
    defaultMessage: 'Team',
    description: 'The Heading for the TEAM Section for the search suggestions',
  },
  VENUES: {
    id: 'Search.Result.VENUES',
    defaultMessage: 'Venues',
    description: 'The Heading for the VENUE Section for the search suggestions',
  },
  POPULAR_SEARCHES: {
    id: 'Search.Result.POPULAR_SEARCHES',
    defaultMessage: 'Popular Searches',
    description: 'The Heading for the POPULAR SEARCHES Section for the search suggestions',
  },
});
